import styles from "./Container.module.css";
import type { ContainerProps } from "./Container.types";

export function Container({ children, as: Tag = "div", className }: ContainerProps) {
  return (
    <Tag className={[styles.container, className].filter(Boolean).join(" ")}>
      {children}
    </Tag>
  );
}
